import { Outlet } from "react-router-dom"
import classes from './AuthLayout.module.scss'
import { useSelector } from "react-redux"
import LanguageDropdown from "../general/LanguageDropdown"
import addMixLogo from "../../assets/images/addmix/identity1.png"
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development"
import { isAccessValid } from "../../utils/isAccessValid"
import { useEffect } from "react"

const AuthLayout = () => {
    const { language } = useSelector(state => state.auth);
    
    const navigate = useNavigate()
    
    useEffect(() => {
        if (isAccessValid()) {
            navigate('/');
        }

        if (window.location.pathname === "/auth") {
            navigate('/auth/access-request');
        }
        
    }, [navigate]);

    return (
        <div className={classes.layout}>
            <div className={classes.leftSide}>
                {/* <div style={{paddingRight: language === "ar" && "10px"}}> */}
                    {/* <img src={lock} alt='logo pic' /> */}
                    {/* <img src={addMixLogo} alt='logo pic' /> */}
                    {/* <h3>{words.WELCOME_TO[language]}<span> {words.ADD_MIX[language]}</span>  </h3> */}
                {/* </div> */}
                <div className={classes.logoBox}>
                    <img className={classes.authImg} src={addMixLogo} alt="layout pic" />
                </div>
            </div>
            <div className={classes.rightSide}>
                <LanguageDropdown/>
                <div className={classes.outlet}>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default AuthLayout